/*
 * Copyright (c) MDR Computer Services Pty Ltd. 

 */

import React from 'react';
import Navbar from 'react-bootstrap/Navbar';

import { useIsAuthenticated } from '@azure/msal-react';
import { SignInButton } from './SignInButton';
import { SignOutButton } from './SignOutButton';

/**
 * 
 * @param props
 */
export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();

    return (
<div className="App">
    <>
    <div className="logo-container">
    <img alt="City-logo" className="logo"  id="citylogo" src={require('./images/city-logo.png')} />         
    <img alt="Summit-logo" className="logo" id="summitlogo"  src={require('./images/summit-logo.jpg')} />
             </div>
   
         <div className="addressWrapper">
              <p>
                Mulgrave<br/>
                10 Nexus Ct,<br/>
                Mulgrave VIC, 3170<br/>
                Ph: (03) 8562 7000<br/>
              </p>
              <p>
                Bayswater<br/>
                1 / 353 Dorset Road,<br/>
                Bayswater VIC, 3153<br/>
                Ph: (03) 9729 3784<br/>

              </p>
                 
              </div>
             
    


     
      
   
                    {isAuthenticated ? <SignOutButton /> : <SignInButton />}
                    {props.children}
             
       
        
   
    
   
              </>
            </div>
         


            
           
            
    );
};
